module.exports = __webpack_public_path__ + "static/media/search-bg-04.a4672f27.jpg";